import {
  GET_REDEMPTION_TYPE,
  GET_REDEMPTION_TYPE_SUCCESS,
  GET_REDEMPTION_TYPE_ERROR,
} from './../../../actionType.js'

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
}

const GetRedemptionType = (state = initialState, action) => {
  switch (action.type) {
    case GET_REDEMPTION_TYPE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      }
      break

    case GET_REDEMPTION_TYPE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      }
      break

    case GET_REDEMPTION_TYPE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default GetRedemptionType
